module.exports = __webpack_public_path__ + "media/newstyle/images/audiobook-background-e01334e6fc2e8d8844653b2bcf9f1570.png";